import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Sidebar from "../Sidebar";
import axios from "axios";
import { format } from "date-fns";
import { FaFileInvoice, FaDownload } from "react-icons/fa";
// With this:
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import TopBar from "../TopBar";

// Set the fonts
pdfMake.vfs = pdfFonts.default || pdfFonts;




const DashboardWrapper = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;
  background-color: #f5f5f5;
  overflow-y: auto;
`;


const PageBody = styled.div`
  flex: 1;
  overflow: auto;
  padding: 20px;     /* or 30px to match other pages */
  background-color: #f5f5f5;
`;

const TableWrapper = styled.div`
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow-x: auto; /* ✅ enables horizontal scroll on small screens */
`;

const Table = styled.table`
  min-width: 800px; /* ✅ ensures table doesn't shrink below a readable size */
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border-bottom: 1px solid #ddd;
    padding: 10px;
    text-align: left;
    white-space: nowrap; /* ✅ keeps content in one line */
  }

  th {
    background-color: #f4f4f4;
  }
`;

const DownloadButton = styled.button`
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #357abd;
  }
`;

const Notification = styled.div`
  background-color: ${({ type }) =>
    type === "success" ? "#d4edda" : "#f8d7da"};
  color: ${({ type }) => (type === "success" ? "#155724" : "#721c24")};
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  border: 1px solid
    ${({ type }) => (type === "success" ? "#c3e6cb" : "#f5c6cb")};
  font-weight: bold;
`;

const Faktura = () => {
  const [orders, setOrders] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const userEmail = currentUser?.Email || "";
  const [invoices, setInvoices] = useState([]);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    const fetchOrdersAndInvoices = async () => {
      try {
        const ordersRes = await axios.get(
          "https://server229256.nazwa.pl/api/orders"
        );
        const filteredOrders = ordersRes.data.filter(
          (order) => order.email === userEmail
        );
        setOrders(filteredOrders);

        const invoicesRes = await axios.get(
          "https://server229256.nazwa.pl/api/generated-invoices"
        );
        const userInvoices = invoicesRes.data.filter(
          (inv) => inv.email === userEmail
        );
        setInvoices(userInvoices);
      } catch (err) {
        console.error("❌ Error fetching data:", err);
      }
    };

    fetchOrdersAndInvoices();
  }, [userEmail]);

  const isInvoiceGenerated = (orderId) => {
    return invoices.some((inv) => inv.orderId === orderId);
  };

  const generateInvoice = async (order) => {
    try {
      const orderId = order._id;
      const res = await axios.post(
        "https://server229256.nazwa.pl/api/generate-invoice",
        { orderId }
      );

      if (res.data?.message?.includes("Invoice generated")) {
        setNotification({
          type: "success",
          text: "✅ Faktura została wygenerowana i zapisana.",
        });

        // Refresh invoice list
        const invoicesRes = await axios.get(
          "https://server229256.nazwa.pl/api/generated-invoices"
        );
        const userInvoices = invoicesRes.data.filter(
          (inv) => inv.email === userEmail
        );
        setInvoices(userInvoices);
      } else {
        setNotification({
          type: "error",
          text: "❌ Wystąpił błąd przy zapisie faktury.",
        });
      }
    } catch (err) {
      console.error(
        "❌ Błąd generowania faktury:",
        err.response?.data || err.message
      );
      setNotification({
        type: "error",
        text: "❌ Błąd podczas generowania faktury.",
      });
    }

    // Hide message after 5 seconds
    setTimeout(() => setNotification(null), 5000);
  };

  const downloadInvoicePdf = async (invoiceId) => {
    try {
      const { data: invoice } = await axios.get(
        `https://server229256.nazwa.pl/api/invoice-pdf/${invoiceId}`
      );
  
      const invoiceNumber = invoice.invoiceNumber || `INV-${invoice._id.slice(-6).toUpperCase()}`;
      const formattedDate = format(new Date(invoice.generatedAt), "yyyy-MM-dd");
      const formattedPurchase = format(new Date(invoice.creationTime), "yyyy-MM-dd");
  
      const brutto = parseFloat(invoice.price);
      const netto = +(brutto / 1.23).toFixed(2);
      const vat = +(brutto - netto).toFixed(2);
  
      const docDefinition = {
        defaultStyle: {
          font: "Roboto",
          fontSize: 10,
        },
        content: [
          { text: `Faktura VAT - ${invoiceNumber}`, style: "header" },
          { text: `Data wystawienia: ${formattedDate}` },
          { text: `Data zakupu: ${formattedPurchase}`, margin: [0, 0, 0, 10] },
  
          {
            columns: [
              {
                width: "50%",
                text: [
                  { text: "Wystawca:\n", bold: true },
                  `${invoice.emitter.nazwa}\n`,
                  `NIP: ${invoice.emitter.nip}\n`,
                  `REGON: ${invoice.emitter.regon}\n`,
                  `Adres: ${invoice.emitter.adres}\n`,
                ],
              },
              {
                width: "50%",
                text: [
                  { text: "Odbiorca:\n", bold: true },
                  `${invoice.klient.nazwa}\n`,
                  `NIP: ${invoice.klient.nip}\n`,
                  `Adres: ${invoice.klient.ulica} ${invoice.klient.nrNieruchomosci}\n`,
                  `${invoice.klient.kodPocztowy} ${invoice.klient.miejscowosc}\n`,
                  `${invoice.klient.gmina}, ${invoice.klient.powiat}, ${invoice.klient.wojewodztwo}\n`,
                ],
              },
            ],
            margin: [0, 0, 0, 10],
          },
  
          {
            table: {
              headerRows: 1,
              widths: ["*", "auto", "auto", "auto"],
              body: [
                [
                  { text: "Produkt", bold: true, fillColor: "#f2f2f2" },
                  { text: "Cena Netto", bold: true, fillColor: "#f2f2f2" },
                  { text: "VAT (23%)", bold: true, fillColor: "#f2f2f2" },
                  { text: "Cena Brutto", bold: true, fillColor: "#f2f2f2" }
                ],
                [
                  invoice.license,
                  `${netto.toFixed(2)} zł`,
                  `${vat.toFixed(2)} zł`,
                  `${brutto.toFixed(2)} zł`
                ]
              ]
            },
            layout: "lightHorizontalLines",
            margin: [0, 0, 0, 20]
          },
  
          {
            text: "Faktura została opłacona.",
            italics: true,
            margin: [0, 0, 0, 20],
          },
  
          {
            columns: [
              { text: '', width: '*' },
              {
                stack: [
                  { text: '...................................................', alignment: 'right' },
                  { text: 'Podpis', alignment: 'right' }
                ],
                width: 'auto'
              }
            ]
          }
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            marginBottom: 10,
          },
        },
        footer: function (currentPage, pageCount) {
          return {
            columns: [
              {
                text: `Strona ${currentPage} z ${pageCount}`,
                alignment: 'center',
                margin: [0, 10, 0, 0]
              }
            ]
          };
        }
      };
  
      pdfMake.createPdf(docDefinition).download(`faktura_${invoiceNumber}.pdf`);
    } catch (err) {
      console.error("❌ PDF download error:", err.message);
      alert("Błąd podczas pobierania faktury.");
    }
  };
  
  
  
  

return (
  <DashboardWrapper>
    <Sidebar />

    <Content>
      <TopBar />

      <PageBody>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 0 16px 0",
            fontSize: "1.2rem",
            fontWeight: "bold",
            color: "#87CEEB",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          <FaFileInvoice />
          Ustawienia i Dane / Lista Zamówień
        </div>

        {notification && (
          <Notification type={notification.type}>{notification.text}</Notification>
        )}

        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>Email</th>
                <th>Licencja</th>
                <th>Cena</th>
                <th>Status</th>
                <th>Data zakupu</th>
                <th>Faktura</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => {
                const matchedInvoice = invoices.find((inv) => inv.orderId === order._id);
                return (
                  <tr key={order._id}>
                    <td>{order.email}</td>
                    <td>{order.license}</td>
                    <td>{order.price} zł</td>
                    <td style={{ color: order.status === "paid" ? "green" : "red" }}>
                      {order.status === "paid" ? "Opłacone" : "Nieopłacone"}
                    </td>
                    <td>{format(new Date(order.creationTime), "yyyy-MM-dd HH:mm")}</td>
                    <td>
                      {matchedInvoice ? (
                        <DownloadButton onClick={() => downloadInvoicePdf(matchedInvoice._id)}>
                          <FaDownload /> Pobierz PDF
                        </DownloadButton>
                      ) : (
                        <DownloadButton onClick={() => generateInvoice(order)}>
                          <FaFileInvoice /> Generuj fakturę
                        </DownloadButton>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </TableWrapper>
      </PageBody>
    </Content>
  </DashboardWrapper>
);

};

export default Faktura;
